var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEuroIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#1f1f1f",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576-144q-112 0-198-64T258-372H144v-72h98q-2-14-2-32t2-40h-98v-72h114q34-100 120-164t198-64q71 0 132.5 27T816-715l-51 51q-36-37-84.5-58.5T576-744q-81 0-145.5 43.5T335-588h241v72H314q-2 11-2.5 29.5T314-444h262v72H335q31 69 95.5 112.5T576-216q56 0 104.5-21.5T765-296l51 51q-46 47-107.5 74T576-144Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEuroIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/euroIcon.a1a1de32.svg";
export { ForwardRef as ReactComponent };